import { CONFIG } from 'config/config';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next)
	// https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: 'es',
		debug: false,
		resources: {
			es: {
				translation: CONFIG.translations.es.main,
			},
			ru: {
				translation: CONFIG.translations.ru.main,
			},
			ua: {
				translation: CONFIG.translations.ua.main,
			},
		},
	});

export default i18n;
